function buildMethods (name, fakeDB, only = ['load', 'add', 'delete']) {
  const obj = {}
  if (only.indexOf('load') > -1) {
    obj.load = function () { return new Promise((resolve, reject) => resolve(JSON.parse(JSON.stringify(fakeDB.list)))) }
  } else { obj.load = () => Promise.reject(new Error(`Action "load" is not implemented for "${name}"`)) }

  if (only.indexOf('add') > -1) {
    obj.add = function (payload) {
      return new Promise((resolve, reject) => resolve(fakeDB.add(payload)))
    }
  } else { obj.add = () => Promise.reject(new Error(`Action "add" is not implemented for "${name}"`)) }

  if (only.indexOf('update') > -1) {
    obj.update = function (payload) {
      return new Promise((resolve, reject) => resolve(fakeDB.update(payload)))
    }
  } else { obj.update = () => Promise.reject(new Error(`Action "update" is not implemented for "${name}"`)) }

  if (only.indexOf('delete') > -1) {
    obj.delete = function (id) {
      return new Promise((resolve, reject) => {
        const index = fakeDB.list.findIndex((p) => p.id === id)
        if (index === -1) return reject(new Error(`No ${name} found with id ${id}`))

        fakeDB.list.splice(index, 1)

        return resolve(id)
      })
    }
  } else { obj.delete = () => Promise.reject(new Error(`Action "delete" is not implemented for "${name}"`)) }

  return obj
}

export default buildMethods
